import BodyText from 'components/atoms/BodyText';
import PrimaryButton from 'components/atoms/Button';
import FormContents from 'components/atoms/Form/FormContents';
import FormField from 'components/atoms/Form/FormField';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import FormTitle from 'components/atoms/Form/FormTitle';
import BlockUI from 'components/molecules/BlockUi';
import FileSelectButton from 'components/molecules/FileSelectButton';
import ConfirmModal from 'components/organismos/ConfirmModal';
import { utilityColor } from 'components/styles';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useAccountTitleCsvUploadDomainForm from './hook';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';

const AdvertisingImportForm: React.FC = () => {
  const {
    setUploadFile,
    uploadFile,
    onSubmit,
    errors,
    confirmModalOpen,
    closeConfirmModal,
    handleSubmit,
    inputValue,
    blocking,
  } = useAccountTitleCsvUploadDomainForm();

  const history = useHistory();

  // Check prototype role staff
  const roleScreen = useSelector((state: Store) => state.auth.roleScreen)

  useEffect(() => {
    if (roleScreen && roleScreen.available === false) {
      history.push('/404')
    }
  }, [roleScreen]);

  return (
    <div>
      <BlockUI blocking={blocking}>
        <FormContents>
          <FormTitle
            title="登録するデータ"
          />
          <BodyText color={utilityColor.error} size="md">※CSVファイルの１行目（ヘッダー行）はインポートされません。</BodyText>
          <FormField>
            <FileSelectButton
              text="CSVファイルをドラッグ＆ドロップ または クリックしてファイルを選択してください"
              ghost={true}
              setFile={setUploadFile}
              value={inputValue}
              accept=".csv"
            />
          </FormField>

          {uploadFile || errors
            ? (
              <FormField
                displayBlock={true}
              >
                <div>
                  {uploadFile?.name}
                </div>
                {errors && errors.map((error) => (
                  <div key={error}>
                    <BodyText color={utilityColor.error}>
                      {error}
                    </BodyText>
                  </div>
                ))}
              </FormField>
            )
            : null}
          <FormSubmitArea>
            {roleScreen && roleScreen.editable === 1 && (
            <PrimaryButton
              text="インポート"
              onClick={handleSubmit}
              disabled={!uploadFile}
            />
            )}
            <div style={{ marginLeft: '12px' }}>
              <PrimaryButton
                text="戻る"
                ghost={true}
              // eslint-disable-next-line no-restricted-globals
                onClick={() => history.goBack()}
              />
            </div>
          </FormSubmitArea>
        </FormContents>

      </BlockUI>

      <ConfirmModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        title="確認メッセージ"
        onSubmit={onSubmit}
        content="ファイルをアップロードします。よろしいですか？"
        items={[]}
      />
    </div>
  );
};


export default AdvertisingImportForm;
